import React, { createContext, useEffect, useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import ListadoTorneos from '../pages/torneos/ListadoTorneos';
import GestionTorneo from '../pages/gestionTorneo/GestionTorneo';
import ParejasPage from '../pages/torneos/EditorTorneo';
import ClasificacionPage from '../pages/gestionTorneo/clasificacion/ClasificacionPage';
import RondaPage from '../pages/gestionTorneo/ronda/RondaPage';
import DetallesPartidaPage from '../pages/gestionTorneo/detallesPartida/DetallesPartidaPage';

// import { AuthContext } from './AuthContext.js___';


function NavRoutes() {
  // const { authorization } = useContext(AuthContext);
//   function ProtectedAdminRoute({ children, checkTenant, redirectTo }) {
//     if (authorization.isTenantSelected() && checkTenant) return <Navigate to="/" />;
//     return authorization.isAdmin() || authorization.isClientAdmin() ? children : <Navigate to={redirectTo ? redirectTo : '/unauthorized'} />;
//   }


  // function CheckedRoute({ children: any, redirectTo }) {
  //   //const sessionItem = SessionStorageHelper.read('TO_userInfo');
  //   if (true) return children;
  //   else {
  //   //   location.reload();
  //   }
  // }

  return (
    // <div className="content-page">
    <Routes>
      <Route
        path="/"
        element={
          // <CheckedRoute>
          <HomePage />
          // </CheckedRoute>
        }
      />
      <Route
        path="/listadoTorneos"
        element={
          // <CheckedRoute>
          <ListadoTorneos/>
          // </CheckedRoute>
        }
      />
      <Route
        path="/gestionTorneo"
        element={
          // <CheckedRoute>
          <GestionTorneo />
          // </CheckedRoute>
        }
      />
      <Route
        path="/edicionTorneo/*"
        element={
          // <CheckedRoute>
          <ParejasPage />
          // </CheckedRoute>
        }
      />
      <Route
        path="/clasificacionTorneo/*"
        element={
          // <CheckedRoute>
          <ClasificacionPage />
          // </CheckedRoute>
        }
      />
      <Route
        path="/iniciarContinuarRonda/*"
        element={
          // <CheckedRoute>
          <RondaPage />
          // </CheckedRoute>
        }
      />
      <Route
        path="*"
        element={
          // <CheckedRoute>
          <HomePage />
          // </CheckedRoute>
        }
      />
    </Routes>
    // </div>
  );
}

export default NavRoutes;
